const getLocale = () => {
  const locale = localStorage.getItem('i18nextLng').substring(0, 2)
  return locale
}

export default getLocale
